import DTCMappingSection from '../../../../components/dtcs/TATMappings/ConnectorMapping/DTCMappingSection'
import SearchConnectorSection from '../../../../components/dtcs/TATMappings/ConnectorMapping/SearchConnectorSection'

const TatDtcMappings = () => {
  return (
    <div className="flex items-stretch flex-grow" style={{ height: '90vh' }}>
      <SearchConnectorSection />
      <div className="flex-1 w-1/3 flex flex-col px-4 py-2 bg-tracer-darker-blue flex-grow"></div>
      <DTCMappingSection />
    </div>
  )
}

export default TatDtcMappings
